import { VisibleAttribute } from './RecipeAttribute'

export const detailedRecipePriorityOrder: VisibleAttribute[] = [
  'numPortions',
  'cookingTime',
  'useWithin',
  'glutenFree',
  'dairyFree',
  'fiveADay',
  'diet',
  'cals',
  'cuisine',
]
